import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import LoadingAdapter from "libs/utils/LoadingAdapter";
import SettingService from "services/SettingService";

let initialState = { list: [] };

export const getBranchList = createAsyncThunk(
  "branch/address",
  async ({ isThailand = false, allStatus = false }) => {
    const response = await SettingService.getBranchList({ isThailand, allStatus });
    return response?.results;
  }
);

const branchSlice = createSlice({
  name: "branch",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(getBranchList, builder, ["list"]);
  },
});

export const selectBranch = (state) => state.branch;

export default branchSlice.reducer;
